import {Component, Input, ViewEncapsulation, SimpleChanges, OnInit, OnChanges} from '@angular/core';
import {User} from 'src/app/shared/models/user';
import {PlatformEvent} from '../../shared/models/information';
import {DevicesService, LangService} from '@satoris/ngx-satoris';
import {ApiService} from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrls: ['./activity-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivityListComponent implements OnInit, OnChanges {
  contexts: {[key: string]: object} = {};
  isWeb: boolean;
  isCustomer: boolean;

  currentPage: number = 1;
  totalPages: number = 1;
  itemsPerPage: number;

  @Input() inputArray: PlatformEvent[];
  @Input() inputContexts: {[key: string]: object};
  @Input() userInfo: User;
  @Input() userPlaceId = '';

  constructor(private devices: DevicesService, private lang: LangService, private api: ApiService) {
    this.isWeb = !this.devices.isDevices('cordova');
  }

  ngOnInit() {
    this.isCustomer = this.api.userRole?.isCustomer;

    if(this.inputArray?.length) {
      if(this.inputContexts && Object.keys(this.inputContexts).length !== 0) {
        this.contexts = this.inputContexts;
      } else {
        this.contexts = {};
        this.inputArray.forEach((e: PlatformEvent) => this.contexts[e.id] = JSON.parse(e.context));
      }
      if(this.isWeb) {
        this.computeTotalPages();
        this.ensureValidPage();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.inputArray && this.inputArray) {
      if(this.inputContexts && Object.keys(this.inputContexts).length !== 0) {
        this.contexts = this.inputContexts;
      } else {
        this.inputArray.forEach((e: PlatformEvent) => {
          if(!this.contexts[e.id]) {
            try {
              this.contexts[e.id] = JSON.parse(e.context);
            } catch (err) {
              console.error('Erreur parsing context:', err);
            }
          }
        });
      }
      if(this.isWeb) {
        this.computeTotalPages();
        this.ensureValidPage();
      }
    }
  }

  getLDesc(item: any): string {
    switch(item.type) {
      case 10:
        return this.lang.transform('activity.descL.10.text',
          {
            person: ((this.contexts[item.id] as { name: string }).name || ('#' + item.actor_id)),
            place: item.place_id,
            claimTypes: item.sharedTypesTranslated ? item.sharedTypesTranslated.join(', ') : ''
          });
      case 9:
        return this.lang.transform('activity.descL.9.text',
          {
            person: ((this.contexts[item.id] as { name: string }).name || ('#' + item.actor_id)),
            place: item.place_id,
            claimTypes: item.sharedTypesTranslated ? item.sharedTypesTranslated.join(', ') : ''
          });
      default:
        return this.lang.transform(`activity.type.DYN${item.type}`);
    }
  }

  getLeftIcon(type: number): string {
    switch(type) {
      case 0: return 'user-plus';
      case 1: return 'user-check';
      case 3: return 'key';
      case 4: return 'check';
      case 6: return 'circle-plus';
      case 7: return 'circle-minus';
      case 8: return 'circle-down';
      case 9: return 'share';
      case 10: return 'share-nodes';
      case 11: return 'ban';
      case 12: return 'user-lock';
      default: return 'info';
    }
  }

  computeTotalPages(): void {
    const totalItems = this.inputArray?.length || 0;
    const perPage = this.itemsPerPage ?? 10;
    this.totalPages = Math.ceil(totalItems / perPage) || 1;
  }

  ensureValidPage(): void {
    if(this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages;
    }
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  onItemsPerPageChange(newValue: number): void {
    this.itemsPerPage = newValue;
    this.computeTotalPages();
    this.currentPage = 1;
  }

  get displayedItems(): PlatformEvent[] {
    if(this.isWeb) {
      const startIndex = (this.currentPage - 1) * (this.itemsPerPage ?? 10);
      const endIndex = startIndex + (this.itemsPerPage ?? 10);
      return (this.inputArray || []).slice(startIndex, endIndex);
    }
    return this.inputArray || [];
  }

  get currentPageIndex(): number {
    return (this.currentPage - 1) * (this.itemsPerPage ?? 10);
  }

  get totalItems(): number {
    return this.inputArray?.length || 0;
  }
}
